import { createContext, useContext } from 'react'

/**
 * Where tooltips, popovers, menus, selects and dialogs mount. Content rendered into another window, such as a picture in
 * picture window, provides that window's body so its overlays open beside their trigger. Unset, they
 * mount on the page body as usual.
 */
const PortalContainerContext = createContext<HTMLElement | undefined>(undefined)

export const PortalContainerProvider = PortalContainerContext.Provider

export function usePortalContainer(): HTMLElement | undefined {
	return useContext(PortalContainerContext)
}
